// src/styles/theme.js
const theme = {
    colors: {
      primary: '#667eea',        // Vibrant purple for key actions and branding
      secondary: '#2196F3',      // Blue for secondary elements
      accent: '#8BC34A',         // Green for success states
      error: '#F44336',          // Red for errors
      warning: '#FFC107',        // Amber for warnings
      dark: '#263238',           // Deep blue-grey for text
      light: '#ECEFF1',          // Light blue-grey for backgrounds
      white: '#FFFFFF',
      black: '#000000',
      background: {
        main: '#F5F5F5',         // Light grey for main background
        paper: '#FFFFFF',        // White for cards and elevated surfaces
        dark: '#121212',         // Dark mode background
      },
      text: {
        primary: '#263238',      // Primary text color
        secondary: '#607D8B',    // Secondary text color
        disabled: '#9E9E9E',     // Disabled text color
        hint: '#9E9E9E',         // Hint text color
      }
    },
    typography: {
      fontFamily: "'Inter', 'Poppins', 'Roboto', sans-serif",
      // Using rem units that scale with root font-size
      h1: { fontSize: '2rem', fontWeight: 600 },      // 32px at 16px base
      h2: { fontSize: '1.75rem', fontWeight: 600 },   // 28px at 16px base
      h3: { fontSize: '1.5rem', fontWeight: 600 },    // 24px at 16px base
      h4: { fontSize: '1.25rem', fontWeight: 500 },   // 20px at 16px base
      h5: { fontSize: '1.125rem', fontWeight: 500 },  // 18px at 16px base
      h6: { fontSize: '1rem', fontWeight: 500 },      // 16px at 16px base
      body1: { fontSize: '1rem', lineHeight: 1.5 },   // 16px at 16px base
      body2: { fontSize: '0.875rem', lineHeight: 1.43 }, // 14px at 16px base
      small: { fontSize: '0.75rem', lineHeight: 1.4 }, // 12px at 16px base
      tiny: { fontSize: '0.625rem', lineHeight: 1.3 }, // 10px at 16px base
    },
    // Spacing scale using rem units
    spacing: {
      xs: '0.25rem',    // 4px
      sm: '0.5rem',     // 8px
      md: '1rem',       // 16px
      lg: '1.5rem',     // 24px
      xl: '2rem',       // 32px
      xxl: '3rem',      // 48px
      xxxl: '4rem',     // 64px
    },
    // Icon sizes using rem units
    iconSizes: {
      xs: '0.75rem',    // 12px
      sm: '1rem',       // 16px
      md: '1.25rem',    // 20px
      lg: '1.5rem',     // 24px
      xl: '2rem',       // 32px
      xxl: '2.5rem',    // 40px
    },
    // Button sizes using rem units
    buttonSizes: {
      sm: {
        height: '2rem',      // 32px
        padding: '0.375rem 0.75rem',
        fontSize: '0.875rem',
      },
      md: {
        height: '2.5rem',    // 40px
        padding: '0.5rem 1rem',
        fontSize: '1rem',
      },
      lg: {
        height: '3rem',      // 48px
        padding: '0.625rem 1.25rem',
        fontSize: '1.125rem',
      },
    },
    shadows: {
      small: '0 2px 8px rgba(0, 0, 0, 0.1)',
      medium: '0 4px 12px rgba(0, 0, 0, 0.15)',
      large: '0 8px 24px rgba(0, 0, 0, 0.2)',
    },
    borderRadius: {
      small: '4px',
      medium: '8px',
      large: '16px',
      full: '9999px',
    },
    transitions: {
      short: '0.2s ease',
      medium: '0.3s ease',
      long: '0.5s ease',
    },
    // Responsive breakpoints
    breakpoints: {
      mobile: '768px',      // Up to 768px - Mobile phones
      tablet: '1024px',     // 769px to 1024px - Tablets (iPad, Android tablets)
      desktop: '1025px',    // 1025px and above - Desktop
    }
  };

  // Media query helpers
  export const device = {
    mobile: `@media (max-width: ${theme.breakpoints.mobile})`,
    tablet: `@media (min-width: calc(${theme.breakpoints.mobile} + 1px)) and (max-width: ${theme.breakpoints.tablet})`,
    desktop: `@media (min-width: calc(${theme.breakpoints.tablet} + 1px))`,
    tabletAndAbove: `@media (min-width: calc(${theme.breakpoints.mobile} + 1px))`,
    mobileAndTablet: `@media (max-width: ${theme.breakpoints.tablet})`,
  };
  
  export default theme;